<template>
    <multiselect
        :options="simpleUnitList"
        :placeholder="placeholder"
        v-bind="$attrs"
        :loading="loading"
        track-by="id"
        label="name"
        :value="selectedUnit"
        @select="onUnitSelected"
    />
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
    props: {
        orgId: null,
        selectedUnitId: {
            default: false,
            required: false,
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            default() {
                return this.$t('label.chooseFilter')
            },
        },
    },

    created() {
        this.getUnitList().then(res => {
            this.units = res
            this.loading = false

            if (this.selectedUnitId) {
                this.setSelectedUnit(this.selectedUnitId)
            }
        })
    },

    data() {
        return {
            selectedUnit: null,
            loading: true,
            units: [],
        }
    },

    watch: {
        // selectedUnitId(newVal, oldVal) {
        //     // console.log('selectedUnitIdWATCH', newVal, oldVal)
        //     this.setSelectedUnit(newVal)
        // },
    },

    methods: {
        ...mapActions({
            getUnits: 'companies/getUnits',
            getUnitList: 'companies/getUnitList',
        }),

        setSelectedUnit(unitId) {
            let selectedUnit = this.units.filter(u => u.id == unitId)[0]

            this.selectedUnit = selectedUnit

            // console.log('SelectedUnitId', unitId, this.selectedUnit)
        },

        onUnitSelected(e) {
            if (!e.id) {
                e = {
                    id: e,
                }
            }

            // console.log('onUnitSelected', e)
            this.setSelectedUnit(e.id)
            this.$emit('select', e)
        },
    },
    computed: {
        ...mapGetters({
            user: 'auth/user',
        }),
        simpleUnitList() {
            return this.units
                .map(u => {
                    if (u.path.length > 1) {
                        u.path.shift()
                    }
                    return {
                        id: u.id,
                        name: u.path.map(s => s.name).join(', '),
                    }
                })
                .sort((a, b) => {
                    if (a.name < b.name) return -1
                    if (a.name > b.name) return 1
                    return 0
                })
        },
    },
}
</script>
